<template>
    <form class="mt-5">
        <div class="row">
            <div class="col-md-12">
                <picture-input :class="[($v.form.profileImage.$error) ? 'is-invalid' : ($v.form.profileImage.$dirty) ? 'is-valid' : '']"
                    ref="pictureInput"
                    width="300" 
                    height="300" 
                    margin="0" 
                    radius="50"
                    accept="image/jpeg,image/png" 
                    size="4" 
                    button-class="btn"
                    :prefill="prefillImage"
                    :zIndex="0"
                    :hideChangeButton="true"
                    :custom-strings="{
                        upload: '<h1>Oeps!</h1>',
                        drag: 'Sleep hier uw foto (jpg of png)'
                    }"
                    @change="onSetPhoto">
                </picture-input>
            </div>
        </div>
        <div class="text-center" v-if="isLoading">
            <loader width="5rem"></loader>
        </div>
        <div class="row" v-else>

            <div class="col-md-6 mt-5">
                <h2>Bedrijfsgegevens</h2>
                <div class="form-group">
                    <label class="label" for="company">Bedrijfsnaam <sup class="red" title="verplicht">*</sup></label>
                    <div class="control" >
                        <input :class="['form-control', ($v.form.company.$dirty) ? ($v.form.company.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Bedrijfsnaam" v-model="form.company" name="company" id="company" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Bedrijfsnaam is verplicht met minimaal 2 karakters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="street">Straat + Huisnummer <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.address.$dirty) ? ($v.form.address.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Straat + Huisnummer" v-model="form.address" name="address" id="street" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Adres is verplicht. Het adres moet een straatnaam en huisnummer bevatten.
                        </div>
                    </div>
                </div>
                <div class="form-group" for="postalCode">
                    <label class="label">Postcode <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.postalCode.$dirty) ? ($v.form.postalCode.$error) ?'is-invalid' : 'is-valid' : '']"  type="text" placeholder="1234 XX" v-model.trim="form.postalCode" name="postalCode" id="postalCode"  @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Postcode is verplicht. Postcode moet het formaat 1234 XX hebben.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="city">Plaats <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="form.city" :class="['form-control', ($v.form.city.$dirty) ? ($v.form.city.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" name="city" id="city" @change="$v.form.city.$touch">
                            <template slot="no-options">
                                Zoek een plaats...
                            </template>
                            <template slot="option" slot-scope="option" class="m-0 p-0">
                                <div class="d-center m-0 p-0" >
                                    {{ option.name }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.name }}
                                </div>
                            </template>
                        </v-select>
                        <div class="invalid-feedback">
                            Plaatsnaam is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group mt-5">
                    <label class="label" for="phoneNumber">Algemeen Telefoonnummer <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.phoneNumber.$dirty) ? ($v.form.phoneNumber.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="Algemeen Telefoonnummer" v-model.trim="form.phoneNumber" name="phoneNumber" id="phoneNumber" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Telefoonnummer is verplicht. Het nummer moet beginnen met 0.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="email">Algemeen Emailadres <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.email.$dirty) ? ($v.form.email.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="Algemeen Emailadres" v-model.trim="form.email" name="email" id="email" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Algemene email is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="website">Website</label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.website.$dirty) ? ($v.form.website.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="https://" v-model.trim="form.website" name="website" id="website" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Ongeldige website. Deze moet beginnen met http:// of https://.
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-6 mt-5">
                <h2>Contactpersoon</h2>
                <div class="form-group">
                    <label class="label" for="contactFirstName">Voornaam <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.contactFirstName.$dirty) ? ($v.form.contactFirstName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Voornaam" v-model="form.contactFirstName" name="contactFirstName" id="contactFirstName" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Voornaam is verplicht met minimaal 2 karakters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="contactLastName">Achternaam <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.contactLastName.$dirty) ? ($v.form.contactLastName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Achternaam" v-model="form.contactLastName" name="contactLastName" id="contactLastName" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Achternaam is verplicht met minimaal 2 karakters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="contactPhone">Mobiel Telefoonnummer <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.contactPhone.$dirty) ? ($v.form.contactPhone.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="Mobiel Telefoonnummer" v-model.trim="form.contactPhone" name="contactPhone" id="contactPhone" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Mobiele telefoonnummer. Het nummer moet beginnen met 06 of 0031.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label" for="contactEmail">Email <sup class="red" title="verplicht">*</sup></label>
                    <div class="control">
                        <input :class="['form-control', ($v.form.contactEmail.$dirty) ? ($v.form.contactEmail.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="Email" v-model.trim="form.contactEmail" name="contactEmail" id="contactEmail" @change="saveProperty('Client', $event)">
                        <div class="invalid-feedback">
                            Email is verplicht.
                        </div>
                    </div>
                </div>
                
                <h2 class="mt-5">Beveiligingsbedrijf?</h2>
                <div class="form-group">
                    <label>Bent u een beveiligingsbedrijf?</label>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="securityCompany" id="securityCompany1" :value="false" v-model="form.isSecurityCompany">
                        <label class="form-check-label" for="securityCompany1">
                            Nee, wij zijn geen beveiligingsbedrijf.
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="securityCompany" id="securityCompany2" :value="true" v-model="form.isSecurityCompany">
                        <label class="form-check-label" for="securityCompany2">
                            Ja, wij zijn een beveiligingsbedrijf <strong>met vergunning</strong>.
                        </label>
                    </div>
                </div>
                <transition name="slide">
                    <div class="form-group" v-if="form.isSecurityCompany">
                        <label class="label" for="contactEmail">Vergunning <sup class="red" title="verplicht">*</sup></label>
                        <div class="control">
                            <input :class="['form-control', ($v.form.permitNumber.$dirty) ? ($v.form.permitNumber.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="ND-" v-model.trim="form.permitNumber" name="permitNumber" id="permitNumber" @change="saveProperty('Client', $event)">
                            <div class="invalid-feedback">
                                Een geldige vergunning is verplicht (ND 1234).
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import vSelect from 'vue-select';
import globalFunctions from '@/mixins/globalFunctions'
import wizardFunctions from '@/mixins/wizardFunctions'
import { required, requiredIf, minLength, maxLength, helpers, email, url, or, not } from 'vuelidate/lib/validators'
import PictureInput from 'vue-picture-input'
import Loader from '@/components/Loader'

const postalcode = helpers.regex('postalcode', /^[1-9][0-9]{3} ?[A-Z]{2}$/);    
const address = helpers.regex('address', /^([1-9][e][\s])*([a-zA-Z]+(([.][\s])|([\s]))?)+[1-9][0-9]*(([-][1-9][0-9]*)|([\s]?[a-zA-Z]+))?$/);
const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);

const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext.toLowerCase()) >= 0;
    }
    return true;
}
const minFileSize = (value) => {
    if(value != null)
    {
        return value.size > 3;
    }
    return true;
}
const validPermit = (value, vm) => {
    if(!vm.isSecurityCompany)
        return true;
        
    if(!!value) 
    {
        if(value.startsWith("ND"))
        {
            value = value.replace("-", "").trim();
            let no = value.split("ND")[value.split("ND").length - 1].trim();
            if(no.length == 4)
            {
                no = Number.parseInt(no);
                if(Number.isInteger(no))
                {
                    vm.permitNumber = "ND " + no;
                    return true;
                }
            }
        }
    }
    return false;
}

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, globalFunctions, wizardFunctions],
        components: {
            PictureInput,
            Loader,
            vSelect
        },
        data() {
            return {
                isLoading: false,
                prefillImage: null,
                cities: [],
                form: {
                    company: '',
                    email: '',
                    phoneNumber: '',
                    address: '',
                    postalCode: '',
                    city: '',
                    website: '',
                    contactFirstName: '',
                    contactLastName: '',
                    contactEmail: '',
                    contactPhone: '',
                    isSecurityCompany: false,
                    permitNumber: '',
                    profileImage: null
                }
            }
        },
        validations: {
            form: {
                company: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(50),
                },
                phoneNumber: {
                    required: requiredIf((vm) => { return vm.contactPhone == null || vm.contactPhone == '' }),
                    or: or(landline, mobile)
                },
                email: {
                    required: requiredIf((vm) => { return vm.contactEmail == null || vm.contactEmail == '' }),
                    email
                },
                website: 
                {
                    url
                },
                address: {
                    required,
                    maxLength: maxLength(100),
                    address
                },
                postalCode: {
                    required,
                    minLength: minLength(6),
                    maxLength: maxLength(7),
                    postalcode
                },
                city: {
                    required
                }, 
                contactFirstName: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(50),
                },
                contactLastName: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(50),
                },
                contactPhone: {
                    required: requiredIf((vm) => { return vm.phone == null || vm.phone == '' }),
                    or: or(landline, mobile)
                },
                contactEmail: {
                    required: requiredIf((vm) => { return vm.email == null || vm.email == '' }),
                    email
                },
                isSecurityCompany: {
                    required
                },
                permitNumber: {
                    required: requiredIf((vm) => { return vm.isSecurityCompany }),
                    validPermit
                },
                profileImage: {
                    required,
                    fileValidation,
                    minFileSize
                }
            }
        },
        methods: {   
            onSearchCity(search, loading) {
                this.$store.dispatch('GET_CITIES', { search, loading });
            }, 
            onSetPhoto (image) {
                if (image) {
                    var type = image.substring(image.indexOf(":") + 1, image.indexOf(";"));
                    this.form.profileImage = this.b64ToFile(image.split(',')[1], type, 'profileImage.' + type.split("/")[1]);
                }
            },
            getProfile() {
                this.isLoading = true;
                return this.$http.get('api/Profile/Client/Wizard/1').then((res) => 
                {
                    this.form.company = res.data.company;
                    this.form.email = res.data.email;
                    this.form.phoneNumber = res.data.phone;
                    this.form.address = res.data.address;
                    this.form.postalCode = res.data.postalCode;
                    this.form.city = res.data.city;
                    this.form.website = (res.data.website) ? res.data.website : '';

                    this.form.contactFirstName = res.data.contactFirstName;
                    this.form.contactLastName = res.data.contactLastName;
                    this.form.contactEmail = res.data.contactEmail;
                    this.form.contactPhone = res.data.contactPhone;
                    this.form.isSecurityCompany = res.data.isSecurityCompany;
                    this.form.permitNumber = res.data.permitNumber;

                    const profileImage = this.b64ToFile(res.data.profileImage, res.data.profileImageContentType, 'profileImage.png');
                    
                    this.form.profileImage = profileImage;     
                    if(profileImage.size > 3)          
                        this.prefillImage = profileImage;

                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            },
            setProfile() {
                return new Promise((resolve, reject) => {
                    this.isLoading = true;
                    var formData = new FormData();

                    for ( var key in this.form) {
                        formData.append(key, this.form[key]);
                    }
                    
                    return this.$http.post('api/Profile/Client/Wizard/1', formData).then(() => {
                        this.isLoading = false;
                        return resolve();
                    }).catch((res) => {
                        this.isLoading = false;
                        return reject(res);
                        //alert('Oops, de vorige stap is niet goed opgeslagen!')
                    })
                });
            }
        },
        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        this.$emit('can-continue', {value: true});
                    } else {
                        this.$emit('can-continue', {value: false});
                    }
                },
                deep: true
            },
            clickedNext(val) {
                if(val === true) {
                    this.$v.form.$touch();
                }
            }
        },
        mounted() {
            //this.$v.form.$touch();
            this.getProfile().then(() => {
                if(!this.$v.$invalid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            });
        }
    }
</script>

<style lang="scss" scoped >
label.custom-file-label {
    display: inline-block !important;
}


/deep/.picture-input  
{
    &.is-invalid {
        .preview-container {
            border: 2px solid #dc3545 !important;
        }
    }
    &.is-valid {
        .preview-container
        {
            border: 2px solid #28a745 !important;
        }
    }
    .picture-inner .picture-inner-text {
        font-size: 1rem;
    }
}
</style>